<template>
  <!-- Modal Overlay -->
  <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <span class="back-button" @click="goBack">
        <img src="@/assets/arrow-left.svg" alt="Back" />
      </span>
      <span class="close-button" @click="closeModal">
        <img src="@/assets/plus.svg" alt="Close" />
      </span>
      <h2>輸入卡號</h2>
      <div class="card-image">
        <img :src="getOfferCardImageURL(selectedOfferCard)" @error="onImageError" />
      </div>
      <h3>{{ selectedOfferCard.bank + ' | ' + selectedOfferCard.name }}</h3>
      <div class="card-num-groups">
        <input
          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          v-model="cardNumberGroup1"
          maxlength="4"
          placeholder="XXXX"
          class="card-input"
          ref="cardInput1"
          @input="handleInput('cardNumberGroup1', 'cardInput2')"
          @keypress="onlyNumber"
          @keydown="handleBackspace('cardNumberGroup1', null, $event)"
        />
        <input
          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          v-model="cardNumberGroup2"
          maxlength="4"
          placeholder="XXXX"
          class="card-input"
          ref="cardInput2"
          @input="handleInput('cardNumberGroup2', 'cardInput3')"
          @keypress="onlyNumber"
          @keydown="handleBackspace('cardNumberGroup2', 'cardInput1', $event)"
        />
        <input
          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          v-model="cardNumberGroup3"
          maxlength="4"
          placeholder="XXXX"
          class="card-input"
          ref="cardInput3"
          @input="handleInput('cardNumberGroup3', 'cardInput4')"
          @keypress="onlyNumber"
          @keydown="handleBackspace('cardNumberGroup3', 'cardInput2', $event)"
        />
        <input
          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          v-model="cardNumberGroup4"
          maxlength="4"
          placeholder="XXXX"
          class="card-input"
          ref="cardInput4"
          @input="handleInput('cardNumberGroup4', 'expireDate')"
          @keypress="onlyNumber"
          @keydown="handleBackspace('cardNumberGroup4', 'cardInput3', $event)"
        />
      </div>
      <div class="card-num-groups expire-date">
        <label>到期日</label>
        <input
          ref="expireDate"

          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          v-model="expireDate"
          maxlength="4"
          placeholder="MMYY"
          class="card-input"

          @input="handleInput('expireDate', 'applyButton')"
          @keypress="onlyNumber"
          @keydown="handleBackspace('expireDate', 'cardNumberGroup4', $event)"          

        />
      </div>
      <button class="apply-button" @click="addCard" ref="applyButton">
        加入紅利折抵信用卡
      </button>
    </div>
  </div>
</template>

<script>
import {  nextTick } from 'vue';
import { onImageError, getFullImageURL } from '@/util/util';

export default {
  data() {
    return {
      showModal: true,
      cardNumberGroup1: '',
      cardNumberGroup2: '',
      cardNumberGroup3: '',
      cardNumberGroup4: '',
      expireDate: '',
    };
  },
  props: {
    selectedOfferCard: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onImageError,
    getFullImageURL,
    closeModal() {
      this.$emit('close-modal');
    },
    goBack() {
      this.showModal = false;
      this.$emit('go-back-to-select-card');
    },
    addCard() {
      const cardNumber =
        this.cardNumberGroup1 +
        this.cardNumberGroup2 +
        this.cardNumberGroup3 +
        this.cardNumberGroup4;
      if (cardNumber.length !== 16 || isNaN(cardNumber)) {
        alert('請輸入有效的16位數信用卡號');
        return;
      }
      this.$emit('card-number-entered', { key: 'cardNumber', value: cardNumber, expireDate: this.expireDate });
    },
    getOfferCardImageURL(offercard) {
      return getFullImageURL( offercard.card_image);
    },
    handleInput(currentGroup, nextRef) {
      const currentValue = this[currentGroup];
      if (currentValue.length === 4) {
        nextTick(() => {
          if (nextRef === 'applyButton') {
            this.$refs.applyButton.focus();
          } else {
            this.$refs[nextRef].focus();
          }
        });
      }
    },
    handleBackspace(currentGroup, prevRef, event) {
      const currentValue = this[currentGroup];
      if (event.key === 'Backspace' && currentValue.length === 0 && prevRef) {
        this.$refs[prevRef].focus();
      }
    },
    onlyNumber(event) {
      const char = String.fromCharCode(event.which);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.cardInput1.focus();
    });
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        nextTick(() => {
          this.$refs.cardInput1.focus();
        });
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  z-index: 2000;
}

.modal-content {
  background-color: white;
  border-radius: 10px;
  width: 640px;
  padding: 24px 30px;
  position: relative;
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 80px;

  box-sizing: border-box;
}

h2 {
  font-size: 24px;
  line-height: 33.6px;
  color: var(--green03);
  margin-top: 0px;
  margin-bottom: 68px;
}

.back-button,
.close-button {
  position: absolute;
  font-size: 24px;
  cursor: pointer;
  color: black;
}

.back-button img,
.close-button img {
  width: 32px;
  height: 32px;
  cursor: pointer;
  color: black;
}

.back-button {
  top: 24px;
  left: 30px;
}

.close-button {
  top: 24px;
  right: 30px;
}

.card-image {
  width: 240px;
  height: 150px;
  border-radius: 12px;
  margin-top: 20px;
  margin: 0;
}

.card-image img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}

h3 {
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);
  margin-top: 24px;
  margin-bottom: 32px;
}

.card-num-groups {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.card-num-groups input {
  padding: 0px 0px;
  width: 140px;
  height: 64px;
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  border: 1px solid var(--gray06);
  border-radius: 8px;
}

.expire-date {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.expire-date label {
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  color: var(--gray15);
  margin-bottom: 8px;
  display: block;
}

.apply-button {
  min-height: 48px;
  padding: 16px 32px 16px 32px;
  border-radius: 99px;

  background-color: var(--green03);
  color: white;
  border: none;

  margin-top: 32px;
  margin-bottom: 32px;

  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;

  box-sizing: border-box;
}

.apply-button:hover {
  background-color: var(--green02);
}

.apply-button:focus {
  outline: none;
  background-color: var(--green02);
}

/* Responsive Styles */
@media (max-width: 560px) {
  .modal-content {
    width: 343px;
    padding: 20px 20px;
  }

  h2 {
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-top: 0px;
    margin-bottom: 40px;
  }

  .back-button img {
    height: 24px;
    width: 24px;
  }

  .back-button {
    top: 20px;
    left: 20px;
  }

  .close-button img {
    height: 24px;
    width: 24px;
  }

  .close-button {
    top: 20px;
    right: 20px;
  }

  h3 {
    font-size: 16px;
    line-height: 24px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .card-image {
    width: 160px;
    height: 100px;
    border-radius: 12px;
    margin-top: 0px;
  }

  .card-num-groups input {
    padding: 0px 0px;
    width: 72px;
    height: 42px;
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border: 1px solid var(--gray06);
    border-radius: 8px;
  }

  .expire-date label {
    font-size: 16px;
    line-height: 21.56px;
  }

  .apply-button {
    padding: 10px 20px 10px 20px;
    border-radius: 99px;

    margin-top: 20px;
    margin-bottom: 32px;

    font-size: 14px;
    line-height: 21.56px;
  }
}
</style>
